import * as requestFromServer from "./billingCrud";
import { billingSlice, callTypes } from "./billingSlice";
import { actions as auth } from "../../Auth/_redux/authRedux";
import { toastOption } from "../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = billingSlice;

export const fetchBillings = (queryParams) => (dispatch) => {
  // dispatch(actions.startCall({ callType: callTypes.list }));
  // return requestFromServer
  //   .findBilling(queryParams)
  //   .then((response) => {
  //     const {
  //       data: { total_items, items },
  //     } = response.data;
  //     dispatch(actions.billingsFetched({ total_items, items }));
  //   })
  //   .catch((error) => {
  //     if (error.response.status === 401) {
  //       toast.error(error.response.data.message, toastOption);
  //       dispatch(auth.logout());
  //     }
  //     error = error.response.data.message;
  //     dispatch(actions.catchError({ error, callType: callTypes.list }));
  //   });
};

export const fetchBilling = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getBillingInvoice()
    .then((response) => {
      if (response.data.data == null) {
        // const { data: billing } = response.data;
        dispatch(
          actions.billingFetched({
            billingInvoice: null,
            invoiceItem: null,
          })
        );
      } else {
        const { data: billing } = response.data;
        dispatch(
          actions.billingFetched({
            billingInvoice: billing,
            invoiceItem: billing.plan_invoice_item,
          })
        );
      }
    })
    .catch((error) => {
      console.log('====================================');
      console.log(error);
      console.log('====================================');
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const createPayment = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createPayment(payload)
    .then((response) => {
      toast.success(response.data.message, toastOption);
      dispatch(actions.billingReload);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getInvoiceList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getInvoiceList(queryParams)
    .then((response) => {
      const {
        data: { total_items, items },
      } = response.data;
      dispatch(
        actions.invoiceFetched({ invoiceList: items, total_items: total_items })
      );
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
